import {
  SAVE_AUTOMATION_RESPONSE,
  ADD_UNIT_AUTOMATION_RESPONSE,
  LIST_UNIT_AUTOMATIONS_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// automationId -> {automation}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case SAVE_AUTOMATION_RESPONSE:
    case ADD_UNIT_AUTOMATION_RESPONSE: {
      return {
        ...state,
        [action.automation.id]: action.automation,
      }
    }
    case LIST_UNIT_AUTOMATIONS_RESPONSE: {
      const s = { ...state }
      const automations = action.automations || []
      automations.forEach((a) => {
        s[a.id] = a
      })
      return s
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
